module.exports = __webpack_public_path__ + "static/img/card2.3bd9314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/card2.png
// module id = d91p
// module chunks = 0